<template>
    <tr v-if="permissions">
        <td :class="{ 'cursor-pointer': !disabled }" @click="toggleView">{{ item ? getViewName(item) : "-" }}</td>
        <td style="width: 20px;" v-for="action in allActions" :key="`${item}_${action}`">
            <v-checkbox
                v-if="allPermissions.includes(action)"
                hide-details
                class="mt-0 mb-0"
                dense
                outlined
                :disabled="disabled"
                @click.stop="onChange(action)"
                :input-value="permissions[item].includes(action)"
            />
        </td>
    </tr>
</template>
<script>
import { mapMutations, mapState } from "vuex";

export default {
    name: "user-permission-table",
    props: ["allPermissions", "item", "allActions", "userRole", "disabled"],
    computed: {
        ...mapState("UserStore", ["activeUser"]),
        permissions: function() {
            return this.activeUser.permissions;
        }
    },
    methods: {
        ...mapMutations("UserStore", ["addPermission", "removeViewPermissions", "resetPermissions"]),
        onChange(action) {
            if (this.disabled) {
                return;
            }
            let permissions = this.permissions[this.item];
            if (permissions.includes(action)) {
                let index = permissions.indexOf(action);
                this.removeViewPermissions({
                    view: this.item,
                    start: index,
                    end: 1
                });
            } else {
                this.addPermission({ action: action, view: this.item });
            }
        },
        getViewName(view) {
            return this.t((view.charAt(0).toUpperCase() + view.slice(1)).replace("_", " "));
        },
        toggleView() {
            if (this.disabled) {
                return;
            }
            let permissions = this.permissions[this.item];
            if (permissions.length > 0) {
                this.removeViewPermissions({
                    view: this.item,
                    start: 0,
                    end: this.activeUser.permissions[this.item].length
                });
            } else {
                this.allPermissions.forEach(ap => {
                    if (!permissions.includes(ap)) {
                        this.addPermission({ action: ap, view: this.item });
                    }
                });
            }
        }
    }
};
</script>
<style></style>
